import { c as _c } from "react/compiler-runtime";
import { PaymentMethodEnum, PrimaryButton } from '@systemeio/ui';
import { storeDefaultErrors } from 'modules/stores/constants/store-default-values';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreEdit } from 'modules/stores/store/hooks/use-store-edit';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { StoreErrorsInterface } from 'modules/stores/types/stores-interface';
import React, { useEffect, useState } from 'react';
import EditModal from 'shared/components/edit-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePaymentMethodsByCurrency } from 'shared/hooks/use-payment-methods-by-currency';
import { twMerge } from 'tailwind-merge';
interface PaymentMethodsEditModalProps {
  errors: Pick<StoreErrorsInterface, 'paymentMethods'>;
}
export const allowedDSPaymentMethods: PaymentMethodEnum[] = [PaymentMethodEnum.stripe_card, PaymentMethodEnum.stripe_ideal, PaymentMethodEnum.stripe_bancontact, PaymentMethodEnum.stripe_applepay, PaymentMethodEnum.paypal_soap, PaymentMethodEnum.paypal_rest, PaymentMethodEnum.gocardless, PaymentMethodEnum.paystack_gh_card, PaymentMethodEnum.paystack_ke_card, PaymentMethodEnum.paystack_ng_card, PaymentMethodEnum.paystack_za_card, PaymentMethodEnum.paystack_eg_card, PaymentMethodEnum.paystack_ci_card, PaymentMethodEnum.cash_on_delivery, PaymentMethodEnum.secure_and_pay, PaymentMethodEnum.mollie, PaymentMethodEnum.flutterwave, PaymentMethodEnum.mercadopago_ar_card, PaymentMethodEnum.mercadopago_br_card, PaymentMethodEnum.mercadopago_cl_card, PaymentMethodEnum.mercadopago_co_card, PaymentMethodEnum.mercadopago_mx_card, PaymentMethodEnum.mercadopago_br_boleto, PaymentMethodEnum.mercadopago_br_pix, PaymentMethodEnum.razorpay, PaymentMethodEnum.xendit_id_card, PaymentMethodEnum.xendit_ph_card];
export default function PaymentMethodsEditModal(t0) {
  const $ = _c(24);
  const {
    errors: propsErrors
  } = t0;
  const {
    storeId
  } = useStoreQuery();
  const {
    data: store
  } = useStore(storeId);
  const [errors, setErrors] = useState(storeDefaultErrors);
  const [opened, setOpened] = useState(false);
  const {
    t
  } = useLocoTranslation();
  const noPaymentMethods = !store?.paymentMethods || store.paymentMethods.length === 0;
  let t1;
  let t2;
  if ($[0] !== noPaymentMethods || $[1] !== propsErrors) {
    t1 = () => {
      if (noPaymentMethods) {
        setErrors(prev => ({
          ...prev,
          ...propsErrors
        }));
      }
    };
    t2 = [propsErrors, noPaymentMethods];
    $[0] = noPaymentMethods;
    $[1] = propsErrors;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      setErrors
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    onSave
  } = useStoreEdit(t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setOpened(false);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onClose = t4;
  const caption = t("dashboard.store.product.checkout.payment_methods");
  let t5;
  if ($[6] !== t) {
    t5 = t("dashboard.payment_methods.currency.change_info");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = store?.currency;
  let t7;
  if ($[8] !== errors || $[9] !== t5 || $[10] !== t6) {
    t7 = {
      currencyChangeMessage: t5,
      currency: t6,
      errors,
      allowedPaymentMethods: allowedDSPaymentMethods
    };
    $[8] = errors;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const {
    currencyAndPaymentMethodsEditFields
  } = usePaymentMethodsByCurrency(t7);
  const t8 = noPaymentMethods && !!propsErrors.paymentMethods && "bg-danger hover:bg-danger";
  let t9;
  if ($[12] !== t8) {
    t9 = twMerge("w-fit", t8);
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = !store;
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setOpened(true);
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t) {
    t12 = t("dashboard.store.product.checkout.edit_payment_methods");
    $[15] = t;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10 || $[18] !== t12 || $[19] !== t9) {
    t13 = <PrimaryButton className={t9} disabled={t10} onClick={t11}>{t12}</PrimaryButton>;
    $[17] = t10;
    $[18] = t12;
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = store && <EditModal caption={caption} opened={opened} onClose={onClose} instance={store} toastCaption={t("dashboard.actions.updated", {
    module: caption
  })} editable={[...currencyAndPaymentMethodsEditFields]} onEdit={data => onSave({
    ...store,
    ...data
  })} />;
  let t15;
  if ($[21] !== t13 || $[22] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  return t15;
}